<template>
	<ul id="select_checkbox_autocomplete_input">
		<div class="template_input">
			<label>{{getLabel(params.label)}} <span v-if="params.compulsory" class="star">*</span>:</label>
			<div id="select_box" v-on:click="open_select_click" ref="collapsable">
				<input v-model="title" v-bind:placeholder='selectTitle' @keydown="open_select" @keyup="keySearch = $event.target.value"></input>
			</div>
			<ul>
				<li v-for="(value, key) in getChoices">
					<input type="checkbox" v-on:click="open_select_click" v-bind:id="params.name+'_'+key" v-bind:value="getLabel(value.label)" v-model="checkboxRes">
					<label v-bind:for="params.name+'_'+key">{{getLabel(value.label)}}</label>
				</li>
			</ul>
		</div>
	</ul>
</template>

	<script>

	import componentTools from '@/libs/componentTools.js';
	import lib from '@/libs/main.js';

	const titleMaxSize = 25;

	export default {
		name: 'select_checkbox_autocomplete_input',
		data() {
			return {
				checkboxRes : [],
				title : '',
				keySearch : "",
				choices : "",
				fields : {
					fr : {
						select : 'Sélectionner'
					},
					en : {
						select : 'Select'
					}
				},
			}
		},
		props : ['params', 'oldValue', 'lang'],
		methods : {
			validate : function(v) {
				return v.length;
			},
			notifyUpdate : function(val) {
				this.$emit('validateField', this.params.name, val);
			},
			getLabel : componentTools.getLabel,
			open_select : function(event){
				let element = event.target;
				while(element && element.id != "select_box") element = element.parentElement;
				if(element) if(element.className != "active") element.classList.toggle("active");
			},
			open_select_click : function(event){
				let element = event.target;
				if(element.type == "checkbox"){
					element = this.$refs["collapsable"];
					if(element) element.classList.toggle("active");
				}
				else {
					while(element && element.id != "select_box") element = element.parentElement;
					if(element) element.classList.toggle("active");
				}
			}
		},
		computed : {
			selectTitle : function(){
				if((!this.checkboxRes || !this.checkboxRes.length)) return this.fields[this.lang].select;
			},
			getChoices : function(){
				var reg = new RegExp(this.keySearch,'gi');
				var res = [];
				var t = this;
				this.params.choices.forEach(function(choice){
					var lab = choice.label;
					if(typeof(lab) == 'object') lab = lab.fr;
					if(lab.toString().match(reg)) res.push(choice);
					if(t.checkboxRes && t.checkboxRes[0] && !lab.toString().match(reg) && lab == t.checkboxRes[0]) res.unshift(choice);
				});
				return res;
			}
		},
		watch: {
			checkboxRes : function(val, old){
				const self = this;
				if(this.params.unique){
					const diff = val.find(e => old.findIndex(k => e === k) == -1);
					if(typeof(diff) != 'undefined') return setTimeout(function(){self.checkboxRes = [diff]}, 50);
				}
				if(this.validate(val)){
					this.notifyUpdate(val);
					this.keySearch = val;
					this.title = val;
				}
				else{
					this.notifyUpdate();
					this.keySearch = '';
					this.title = '';
				}
			},
			oldValue : function(val){
				if(!val) this.checkboxRes = [];
			}
		},
		mounted : function(){
			if(Array.isArray(this.oldValue) && this.oldValue.length) this.checkboxRes = this.oldValue;
		}
	};
	</script>




// WEBPACK FOOTER //
// src/components/candidate_forms/select_checkbox_autocomplete_input.vue